'use client';

import { FC, useState } from 'react';
import { useTranslations } from 'next-intl';
import HotdeskButton from '@/hotdesk-ui/components/shared/HotdeskButton';
import styles from './AmenitiesGrid.module.scss';
export interface AmenitiesGridProps {
  amenities: Array<{
    id?: number | string;
    name: string;
    url?: any;
  }>;
  initialVisible?: number;
}
const AmenitiesGrid: FC<AmenitiesGridProps> = ({
  amenities,
  initialVisible = 8
}) => {
  const t = useTranslations('workspace-details');
  const [showAll, setShowAll] = useState(false);
  if (!amenities || amenities.length === 0) return null;
  const visible = showAll ? amenities : amenities.slice(0, initialVisible);
  return <section className={styles.section} data-sentry-component="AmenitiesGrid" data-sentry-source-file="AmenitiesGrid.tsx">
            <h2 className={styles.heading}>{t('amenities')}</h2>
            <div className={styles.grid}>
                {visible.map((amenity, i) => <div key={amenity.id ?? i} className={styles.item}>
                        {/* eslint-disable-next-line @next/next/no-img-element */}
                        <img src={amenity.url || '/assets/icons/aminities.svg'} alt={amenity.name} width={24} height={24} className={styles.icon} />
                        <span className={styles.label}>{amenity.name}</span>
                    </div>)}
            </div>
            {amenities.length > initialVisible && <div className={styles.showAllWrap}>
                    <HotdeskButton variant="secondary" size="md" onClick={() => setShowAll(!showAll)}>
                        {showAll ? t('showLess') : `${t('showAll')} ${amenities.length} ${t('amenities')}`}
                    </HotdeskButton>
                </div>}
        </section>;
};
export default AmenitiesGrid;